import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello, I am <span className="purple">Soheel Gadad</span> from{" "}
            <span className="purple">Ponda, Goa</span>. I am a dedicated IT
            professional with{" "}
            <span className="purple">2.8 years of experience </span>
            in system administration, holding a{" "}
            <span className="purple">
              Master of Computer Applications (MCA)
            </span>{" "}
            from <span className="purple">Chandigarh University</span>.
            <br />
            <br />
            I am passionate about{" "}
            <span className="purple">cloud architecture</span>,{" "}
            <span className="purple">automation</span>, and building{" "}
            <span className="purple">scalable full-stack applications</span>.
            <br />
            <br />
            Outside of my technical career, I maintain a balanced lifestyle by
            traveling, gaming, and working out. I constantly strive to build
            things that make a difference.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;